import { useTranslation } from "react-i18next";
import { motion, useInView } from "framer-motion";
import { useRef } from "react";

export default function CTASection() {
  const { t, i18n } = useTranslation();
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-80px" });
  const isRTL = i18n.language?.startsWith("ar");
  const whatsappMessage = isRTL
    ? "مرحباً، أرغب في طلب عرض سعر من ابراج الرفوف."
    : "Hello, I would like to request a quote from Arafouf.";
  const whatsappLink = `https://wa.me/966532785554?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <section
      id="cta"
      className="relative w-full min-h-[500px] md:min-h-[600px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <motion.img
          src="/assets/images/18.jpg"
          alt="Modern warehouse facility"
          className="w-full h-full object-cover object-top"
          initial={{ scale: 1.1 }}
          animate={isInView ? { scale: 1 } : { scale: 1.1 }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        />
        <div className="absolute inset-0 bg-black/60" />
      </div>

      <div ref={ref} className="relative z-10 w-full px-4 md:px-8 lg:px-12 py-16 md:py-24">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8">
          <motion.div
            className="max-w-2xl"
            initial={{ opacity: 0, x: -40 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -40 }}
            transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight">
              {t("cta.heading")}
            </h2>
          </motion.div>
          <motion.div
            className="flex flex-col items-start lg:items-end gap-4"
            initial={{ opacity: 0, x: 40 }}
            animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 40 }}
            transition={{ duration: 0.7, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
          >
            <p className="text-base md:text-lg text-white/80">
              {t("cta.desc1")}
              <br />
              {t("cta.desc2")}
            </p>
            <motion.a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 bg-brand text-white font-semibold px-8 py-4 rounded-full hover:bg-brand-dark transition-colors whitespace-nowrap cursor-pointer"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {t("cta.button")}
              <span className="w-8 h-8 flex items-center justify-center bg-white/20 rounded-full">
                <i className="ri-whatsapp-line text-white text-sm" />
              </span>
            </motion.a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}